import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { AZListSchema } from './schema';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  AZListBlock: {
    id: 'AZListBlock',
    defaultMessage: 'A-Z List',
  },
});

const AZListData = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();

  return (
    <BlockDataForm
      schema={AZListSchema({ ...props, intl })}
      title={intl.formatMessage(messages.AZListBlock)}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default AZListData;
